import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Tabela from "../../components/Tabela";
import { toast } from "react-toastify";
import { getGrupoById } from "../../api/checkilstApi";
import { GrupoPergunta, Pergunta } from "../../types/checklistData";

const Perguntas: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [perguntas, setPerguntas] = useState<Pergunta[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGrupo = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const grupoData: GrupoPergunta = await getGrupoById(token, id!);
        setPerguntas(grupoData.perguntas);
      } catch (error) {
        toast.error("Erro ao buscar Grupo de Perguntas!");
        console.error("Erro ao buscar Grupo de Perguntas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGrupo();
  }, [id]);

  const handleViewRespostas = (perguntaId: string) => {
    navigate(`/pergunta/${perguntaId}/respostas`);
  };

  const handleBack = () => {
    navigate(-1); 
  };

  const handleEditPergunta = (id: string) => {
    navigate(`/editarPergunta/${id}`);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_checklist_pergunta", label: "Descrição da Pergunta" },
  ];

  const dadosConvertidos = perguntas.map((pergunta) => ({
    ...pergunta,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Perguntas"
        colunas={colunas}
        dados={dadosConvertidos}
        loading={loading}
        showVisibilityIcon={true}
        onView={handleViewRespostas}
        onEdit={handleEditPergunta}
        showBackButton={true} 
        onBack={handleBack} 
      />
    </Box>
  );
};

export default Perguntas;
